<dx-popup [(visible)]="popupVisible" [closeOnOutsideClick]="true" title="Add Money to your Merchant Account"
    [width]="600" [height]="600" (onHiding)="handlePopupHiding($event)">

    <div>
        <form (submit)="onFormSubmit($event)">
            <dx-form #formRef [formData]="formData" [colCount]="2">
                <dxi-item dataField="amount" [isRequired]="true" editorType="dxNumberBox"
                    [editorOptions]="numberBoxOptions">
                    <dxo-label text="Amount"></dxo-label>
                    <dxi-validation-rule type="required" message="Amount is required"></dxi-validation-rule>
                    <dxi-validation-rule type="numeric" message="Amount must be a number"></dxi-validation-rule>
                    <dxi-validation-rule type="range" [min]="0.1"
                        message="Amount must be at least 1"></dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="transferTo" editorType="dxSelectBox" [editorOptions]="{
                    items: accountsDataSource,
                    displayExpr: 'name',
                    valueExpr: 'id'
                }">
                    <dxi-validation-rule type="required"
                        message="You must select account to transfer"></dxi-validation-rule>
                </dxi-item>

                <dxi-item [colSpan]="2">
                    <dxo-label text="Deposit Amount" location="left"></dxo-label>
                    <div style="text-align: right;">{{ formData.depositAmount | currency:'ZAR' }}</div>
                </dxi-item>

                <dxi-item [colSpan]="2">
                    <dxo-label text="Top-up fee" location="left"></dxo-label>
                    <div style="text-align: right;">{{ formData.depositFee | currency:'ZAR'}}</div>
                </dxi-item>

                <dxi-item colSpan="2">
                    <hr style="margin: 0;">
                </dxi-item>

                <dxi-item colSpan="2" location="left">
                    <dxo-label text="Amount added to your merchant account:"></dxo-label>
                    <div style="text-align: right;">{{ formData.total | currency:'ZAR'}}</div>
                </dxi-item>

                <dxi-item dataField="type" colSpan="2">
                    <dx-button-group [items]="transactionTypeDataSource" [selectedItemKeys]="selectedItemKeys"
                        selectionMode="single" (onSelectionChanged)="onSelectionChanged($event)">
                    </dx-button-group>

                    <div *ngIf="formData.type==1" style="margin-top: 10px">
                        <h5>
                            Direct debit instruction
                        </h5>
                        Account <br>
                        {{merchant?.fundingAccount}}

                    </div>
                    <div *ngIf="formData.type==2">
                        <h5>
                            Payment instruction
                        </h5>
                    </div>
                </dxi-item>

                <dxi-item colSpan="2" itemType="button" [buttonOptions]="registerButtonOptions">
                </dxi-item>
            </dx-form>
        </form>
    </div>
</dx-popup>